/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';

interface TaskCardContainerProps {
  activeColor: string;
}
interface RoundCardContainerProps extends TaskCardContainerProps {
  active: boolean;
}

export const DrawerContainer = styled.aside`
  flex: 1 0 24%;
  min-width: 17em;
  max-width: 19em;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.15) 0 2px 4px;
  z-index: 5;
`;

export const SaveNoteButton = styled(NeuButton)`
  float: right;
`;
export const CardsContainer = styled.div`
  height: calc(100% - 40px);
  overflow-y: scroll;
`;
export const NoteCardsContainer = styled(CardsContainer)`
  height: calc(100% - 200px);
  overflow-y: scroll;
`;
export const NotesContainer = styled(CardsContainer)`
  overflow-y: hidden;
`;

export const NoteForm = styled.div`
  gap: 0.5em;
`;

export const RoundCardContainer = styled.div<RoundCardContainerProps>`
  border-bottom: 1px solid #b0b0b0;
  background: ${({ active, activeColor }) => (active ? activeColor : '')};
  &:hover {
    background: ${({ activeColor }) => activeColor};
    cursor: pointer;
  }
`;

export const TaskCardContainer = styled.div<TaskCardContainerProps>`
  border-bottom: 1px solid #b0b0b0;
  :hover {
    background: ${({ activeColor }) => activeColor};
    cursor: pointer;
  }
`;

export const HorizontalDivider = styled.hr`
  margin-top: 1em;
  border-top: 1px solid rgb(224, 224, 224);
`;
